var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiFi1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8533761,32.3457031 C20.0193917,32.3457031 20.1854074,32.2993164 20.351423,32.206543 C20.5174386,32.1137695 20.742048,31.9257812 21.0252511,31.6425781 L24.5994699,28.2148438 C24.7166574,28.1074219 24.7850167,27.9780273 24.804548,27.8266602 C24.8240792,27.675293 24.7850167,27.5361328 24.6873605,27.4091797 C24.1990792,26.7939453 23.5301339,26.2568359 22.6805246,25.7978516 C21.8309152,25.3388672 20.8885324,25.109375 19.8533761,25.109375 C18.7986886,25.109375 17.8416574,25.3486328 16.9822824,25.8271484 C16.1229074,26.3056641 15.4588449,26.8623047 14.9900949,27.4970703 C14.9119699,27.6142578 14.8851144,27.7363281 14.9095285,27.8632812 C14.9339425,27.9902344 15.0047433,28.1074219 15.1219308,28.2148438 L18.6815011,31.6425781 C18.9647042,31.9160156 19.191755,32.1015625 19.3626535,32.1992188 C19.5335519,32.296875 19.6971261,32.3457031 19.8533761,32.3457031 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFi1);
export default __webpack_public_path__ + "static/media/WiFi1.b78d464dd1a6c8bb7869421ad169e0d8.svg";
export { ForwardRef as ReactComponent };